"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
}, _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M3.07.5c0-.28.23-.5.5-.5h4.86c.27 0 .5.22.5.5V2a.5.5 0 01-.03.17h2.6a.5.5 0 110 1h-.97a.5.5 0 01.07.25v7.08c0 .83-.68 1.5-1.5 1.5H2.84a1.5 1.5 0 01-1.5-1.5V3.42c0-.09.02-.17.06-.25H.5a.5.5 0 010-1h2.6A.5.5 0 013.07 2V.5zm-.8 2.67a.5.5 0 01.07.25v7.08c0 .28.22.5.5.5H9.1a.5.5 0 00.5-.5V3.42c0-.09.02-.17.06-.25H2.27zM7.93 2c0 .06 0 .12.03.17H4.04A.5.5 0 004.07 2V1h3.86v1z"
}));

exports.default = _default;